import * as React from "react";
import { StyledStep } from "../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  // {
  //   selector: ".step-2",
  //   content: () => (
  //     <StyledStep>
  //       <h1 className="step-title">Top Behaviours</h1>
  //       <p className="step-text">
  //         Here are the top behaviours that are having an impact on your learning
  //         that together we need to improve, great news, your Performance Learning lessons will
  //         help you do this, onwards and upwards!
  //       </p>
  //     </StyledStep>
  //   ),
  //   style: { background: "#2a2a2a" },
  // },
  // {
  //   selector: ".step-1",
  //   content: () => (
  //     <StyledStep>
  //       <h1 className="step-title">Bottom Behaviours</h1>
  //       <p className="step-text">
  //         Great work! These are the behaviours you are nailing that affect your
  //         learning. Keep up the good work!
  //       </p>
  //     </StyledStep>
  //   ),
  //   style: { background: "#2a2a2a" },
  // },
  {
    selector: ".step-3",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Your Course Journey</h1>
        <p className="step-text">
          Awesome work completing your Performance Learning Assessment, now Performance Learning can see just
          how to help you ace your learning. Here's your bespoke course journey!
        </p>
        {/* <p className="step-text">
          On your Performance Learning Journey, you'll see your pit stops, these are the lessons
          you'll be completing. Onwards and upwards!
        </p> */}
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-4",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Data Center</h1>
        <p className="step-text">
          This is the one stop place for you to see your progress - take a look
          and see how you're doing! If you want any help I'm always here so get
          in touch.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-5",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Lessons</h1>
        <p className="step-text">
          Here are all the lessons that Performance Learning knows will help you on your
          learning journey. If a lesson is greyed out, you've already completed
          it well done! Now move on to the next lesson.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-6",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Lesson Plan</h1>
        <p className="step-text">
          It's important to keep track of your time management, here I'll show
          you what lessons you have coming up so that you can make sure you're
          fully prepared!
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/Home/StudentHomeTour.tsx